/**
 * @desc Yung-提交表单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
